<template>
  <section class="products" id="products">
    <div class="container">
      <div class="section-title">
        <h2 class="gradient-text">Wheelchair Product Showcase</h2>
        <p>We focus on the research, development, and sales of high-quality wheelchairs to meet the diverse needs of different users</p>
      </div>
      <div class="products-grid responsive-grid">
        <div v-for="product in products" :key="product.id" class="product-card card-shadow hover-lift">
          <div class="product-image img-hover">
            <img :src="product.img" :alt="product.name" />
          </div>
          <div class="product-content">
            <h3>{{ product.name }}</h3>
            <p>{{ product.description }}</p>
            <a href="#" class="learn-more link-hover">Learn More →</a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Products',
  props: {
    products: Array
  }
}
</script>

<style scoped>
.products {
  padding: 6rem 2rem;
  background: white;
  position: relative;
}

.products::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent, #2c5aa0, transparent);
}

.container {
  max-width: 1200px;
  margin: 0 auto;
}

.section-title {
  text-align: center;
  margin-bottom: 4rem;
}

.section-title h2 {
  font-size: 3rem;
  color: #333;
  margin-bottom: 1rem;
  font-weight: 300;
  position: relative;
}

.section-title h2::after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 3px;
  background: linear-gradient(90deg, #2c5aa0, #4a7bc8);
  border-radius: 2px;
}

.section-title p {
  font-size: 1.3rem;
  color: #666;
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.6;
}

.products-grid {
  gap: 2.5rem;
  margin-top: 3rem;
}

.product-card {
  background: white;
  border-radius: 20px;
  overflow: hidden;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  border: 1px solid rgba(44, 90, 160, 0.1);
  position: relative;
}

.product-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #2c5aa0, #4a7bc8);
  transform: scaleX(0);
  transition: transform 0.4s ease;
}

.product-card:hover::before {
  transform: scaleX(1);
}

.product-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 20px 40px rgba(44, 90, 160, 0.15);
}

.product-image {
  height: 220px;
  background: linear-gradient(135deg, #e3f2fd, #bbdefb);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

.product-image img {
  max-width: 100%;
  max-height: 180px;
  object-fit: contain;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(44,90,160,0.08);
  background: #fff;
}

.product-image::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(45deg, rgba(44, 90, 160, 0.1), rgba(74, 123, 200, 0.1));
  opacity: 0;
  transition: opacity 0.3s ease;
}

.product-card:hover .product-image::before {
  opacity: 1;
}

.product-content {
  padding: 2.5rem;
}

.product-card h3 {
  font-size: 1.5rem;
  margin-bottom: 1rem;
  color: #333;
  font-weight: 600;
}

.product-card p {
  color: #666;
  margin-bottom: 1.5rem;
  line-height: 1.7;
  font-size: 1rem;
}

.learn-more {
  color: #2c5aa0;
  text-decoration: none;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  transition: all 0.3s ease;
  font-size: 1rem;
}

.learn-more:hover {
  gap: 1rem;
  color: #4a7bc8;
}

.gradient-text {
  background: linear-gradient(45deg, #2c5aa0, #4a7bc8);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

@media (max-width: 768px) {
  .products {
    padding: 4rem 1rem;
  }
  .section-title h2 {
    font-size: 2.5rem;
  }
  .section-title p {
    font-size: 1.1rem;
  }
  .product-content {
    padding: 2rem;
  }
  .product-image {
    height: 160px;
  }
  .product-image img {
    max-height: 120px;
  }
}
@media (max-width: 480px) {
  .section-title h2 {
    font-size: 2rem;
  }
  .product-card h3 {
    font-size: 1.3rem;
  }
  .product-image {
    height: 100px;
  }
  .product-image img {
    max-height: 70px;
  }
}
</style> 